import client from '@stores/apollo'
import gql from 'graphql-tag'
import { IEmployeeImport, IPageInfo } from '@api'
import { EmployeeImportFragment, PageInfoFragment } from '@api/fragments'

export default function list(after?: string): Promise<{
  pageInfo: IPageInfo
  imports: IEmployeeImport[]
}> {
  return client.gql.query({ query, variables: { after } }).then(
    ({
      data: {
        viewer: {
          company: {
            imports: { edges, pageInfo },
          },
        },
      },
    }: {
      data: {
        viewer: {
          company: {
            imports: {
              pageInfo: IPageInfo
              edges: { node: IEmployeeImport }[]
            }
          }
        }
      }
    }) => ({ pageInfo, imports: edges.map(({ node }) => node) })
  )
}

const query = gql`
  query importsQuery($after: String) {
    viewer {
      company {
        imports(after: $after, first: 20) {
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              ...EmployeeImportFragment
            }
          }
        }
      }
    }
  }
  ${EmployeeImportFragment}
  ${PageInfoFragment}
`
